module.exports = __webpack_public_path__ + "static/photograph-banner-mobile-91ad6f38cf076648c17c4f55ac18847d.jpg";